class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');

    // Add hover behavior for desktop
    if (window.matchMedia('(min-width: 990px)').matches) {
      this.addEventListener('mouseenter', this.onMouseEnter.bind(this));
      this.addEventListener('mouseleave', this.onMouseLeave.bind(this));

      // Make summary clickable to follow link
      const summary = this.mainDetailsToggle.querySelector('summary');
      const link = this.getParentLink();
      if (link && summary) {
        summary.addEventListener('click', (event) => {
          // If menu is already open and user clicks, follow the link
          if (this.mainDetailsToggle.hasAttribute('open')) {
            event.preventDefault();
            window.location.href = link;
          }
        });
      }
    }
  }

  getParentLink() {
    // Extract the parent menu item's URL from the Liquid template
    // The summary element doesn't have an href, but we need to navigate to /collections/all
    const summaryText = this.mainDetailsToggle.querySelector('summary span')?.textContent.trim().toLowerCase();
    if (summaryText === 'produkte' || summaryText === 'products') {
      return '/collections/all';
    }
    return null;
  }

  onMouseEnter() {
    if (window.matchMedia('(min-width: 990px)').matches) {
      this.mainDetailsToggle.setAttribute('open', '');
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
    }
  }

  onMouseLeave() {
    if (window.matchMedia('(min-width: 990px)').matches) {
      setTimeout(() => {
        if (!this.contains(document.activeElement)) {
          this.close();
        }
      }, 100);
    }
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
